import { Action } from 'store/store';
import { WidgetActionPayload } from 'widgets/store/actions';

export enum MyPortfolioCapsulesActionType {
    INITIALISE = 'INITIALISE_MY_PORTFOLIO_CAPSULES',
}

export type MyPortfolioCapsulesInitialiseAction = Action<
    MyPortfolioCapsulesActionType.INITIALISE,
    WidgetActionPayload
>;

export const myPortfolioCapsulesInitialise: (
    widgetKey: string
) => MyPortfolioCapsulesInitialiseAction = (widgetKey) => ({
    type: MyPortfolioCapsulesActionType.INITIALISE,
    payload: { widgetKey },
});
